import React from 'react'
import { Modal } from '@material-ui/core'
import styled from '../../../theme'
import alert from '../../../assets/integrations/information.svg'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/Airbnb/Button'

const Wrapper = styled.div`
  width: 356px;
  min-width: 356px;
  height: 220px;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.5);
  stroke-width: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: relative;
  outline: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 15px 15px 20px;
`

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Header = styled.div`
  background-size: cover;
  display: flex;
  align-items: center;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  color: #696a6d;
  text-decoration: none solid rgb(105, 106, 109);
  text-align: justify;
  font-weight: 500;
`

const Info = styled.div`
  background-size: cover;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  color: #696a6d;
  text-decoration: none solid rgb(105, 106, 109);
  text-align: justify;
`

function LeaveModal({ open, handleClose, action }: IListingModal) {
  const { t } = useTranslation()

  return (
    <Modal open={open} onClose={action}>
      <Wrapper>
        <Header>
          <img
            src={alert}
            alt={'alert'}
            style={{ width: '40px', height: '40px', marginRight: '10px' }}
          />
          {t('OUT_4835_pop_up_1')}
        </Header>
        <Info>{t('OUT_4835_pop_up_2')}</Info>
        <Info style={{ fontWeight: 500 }}>{t('OUT_4835_pop_up_3')}</Info>
        <Actions>
          <Button onClick={handleClose} secondary={true}>
            {t('OUT_4835_exit')}
          </Button>
          <Button
            style={{
              backgroundColor: '#07a944',
            }}
            onClick={action}
          >
            {t('BED_4400_account_deletion_survey_button_confirm')}
          </Button>
        </Actions>
      </Wrapper>
    </Modal>
  )
}

export interface IListingModal {
  open: boolean
  handleClose: () => void
  action: () => void
}

export default LeaveModal
